import React from "react";
import {Link} from "react-router-dom";
import ReactTable from "react-table";
import {Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import classNames from 'classnames';

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {confirmAlert} from "react-confirm-alert";
import {PrintBarcodeModal} from '../../containers/Print';
import ProductLong from "components/Labels/ProductLong";
import ProductShort from "components/Labels/ProductShort";

import Select from "react-select";
import CollectionOverride from "components/CollectionOverride";
import UniversalModalOverride from "../UniversalModalOverride";
import {Objects} from "../index";
import TextField from "@material-ui/core/TextField";


export default class ProductsEForm extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Products._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.caliber = '';
		this.state.caliber_error = '';
		this.state.calibers = null;
		this.state.manufacturer = '';
		this.state.manufacturer_error = '';
		this.state.manufacturers = null;
		this.state.type = '';
		this.state.type_error = '';
		this.state.types = null;
		this.state.products = [];
		this.state.products_error = "";
		this.state.loading = false;
		this.state.not_acquired_error = false;
		this.state.already_acquired_error = false;
		this.state.use_default_form_one_questions = true;
		this.state.showEFormModal = false;
		this.state.selectedId = null;

	}

	customStyles = {
		menu: (provided) => ({
			...provided, zIndex: 9999
		})
	};

	handleSelectPropertyUpdate = (property, value, linked, object) => {
		let updatedState;
		if (linked) {
			if (object && object.hasOwnProperty('binary_id')) {
				updatedState = {
					[linked]: object,
					[property]: value,
				};
			} else {
				updatedState = {
					[linked]: object,
					[property]: value,
				};
			}
		} else {
			updatedState = {
				[property]: value,
			};
		}
		this.setState(updatedState);
		this.doFilter({'value': value}, {'name': property});
	};

	clearFilters = () => {
		this.setState({
			key: Math.random(),
			filter: {},
			search: '',
			startDate: '',
			endDate: '',
			filterLocation: null,
			filterStatus: null,
			filterUsed: null,

			caliber: '',
			calibers: null,
			manufacturer: '',
			manufacturers: null,
			type: '',
			types: null,
		});
		let path = window.location.pathname.replaceAll('/', ' ').titleCase().replaceAll(' ', '');
		localStorage.removeItem('table-preferences-' + path);
	}

	/**
	 *
	 * @param products
	 * @param key
	 * @param valueToRemove
	 * @returns {*}
	 */
	removeObjectByKeyValue(products, key, valueToRemove) {
		return products.filter(product => product[key] !== valueToRemove);
	}

	handleToggleModalAdd = () => {
		this.setState({modalAdd: true});
	}

	handleReportProductClose = () => {
		this.setState({modalAdd: false})
	}


	setFlagMessage = (event) => {
		this.setState({[event.target.name]: event.target.value});
	};


	handleTextFieldPropertyUpdate = (property, value) => {
		this.setState({
			[property]: value,
			[property + '_error']: '',
		});
	};




	handleEForm1 = (e) => {
		const id = parseInt(e.currentTarget.id);
		this.setState({ showEFormModal: true, selectedId: id });
	};

	randomHash = async (length) => {
		let result = '';
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		const charactersLength = characters.length;
		let counter = 0;
		while (counter < length) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
			counter += 1;
		}
		return result;
	}


	render() {
		const {data, pages, limit, loading,columnsAnchor} = this.state;
		const extraColumns = [
		];
		const columns = [
			{
				Header: "Serial",
				id: "serial",
				accessor: obj => obj.serial_number
			},

			{
				Header: "SKU",
				accessor: "sku",
			},
			{
				Header: "Type",
				accessor: "type",
			},
			{
				Header: "Model",
				accessor: "model",
			},
			{
				Header: "Manufacturer",
				id: 'manufacturer',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.manufacturer ? obj.manufacturers.name : obj.manufacturer_other)
			},
			{
				Header: "Caliber",
				id: 'caliber',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.caliber ? obj.calibers.name : obj.caliber_other)
			},
			...extraColumns,
			{
				Header: "Status",
				id: 'status',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.status ? obj.product_statuses.name : "")
			},
			{
				Header: "Location",
				id: 'location',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.location ? obj.locations.name_display || obj.locations.name : "")
			},
			{
				Header: "Acq. Date",
				id: "acquisition_date",
				width: 160,
				/** @param {Products_Object} obj */
				accessor: obj => {
					return obj.acquisition_date ? moment(obj.acquisition_date)
						.local()
						.format("MM/DD/YYYY hh:mm A") : 'Never Acquired'
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/products/${props.original._id}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={"fa fa-pencil"}/></Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/products/${props.original._id}#history`}>
								<Button color="default" size={"sm"} block={true}>
									<i className={"fa fa-file-text-o"}/></Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 200,
				Cell: props => {
					return (
						<Button
							id={props.original.pkey}
							// binary_id={props.original.binary_id}
							// data-id={"product-"+props.original.serial_number}
							color="blue-hoki"
							size={"sm"}
							block={true}
							onClick={this.handleEForm1}>
							<i className={"btn-btn primary"}/>
							Launch Assisted Form 1
						</Button>
					);
				}
			}

		];
		/** @type {Products_Properties} properties */
		let properties = this.model.properties;
		/** @type {Products_Object} object */
		let object = this.state;

		return (
			<Card>
				<CardContent>
					<Alert color="warning">
						⚠️ Notice: The FFL Boss extension automates data entry for your convenience. Because ATF and other government websites may update their forms at any time, you are responsible for verifying that all autofilled information is accurate and current before submission.
					</Alert>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Products', "")}
								{this.renderLocationFilter()}
								<div className="statusFilter" style={{width: '160px'}}>
									<Select
										styles={this.customStyles}
										className={classNames('basic-single', {hasSelection: this.state.filter.status != null && this.state.filter.status.length})}
										classNamePrefix="select"
										onChange={this.doFilter}
										value={this.state.filterStatus}
										isClearable={true}
										isSearchable={true}
										name="status"
										placeholder={"Status..."}
										options={[
											{value: null, label: 'All'},
											{value: 1, label: 'In Stock'},
											{value: 2, label: 'Sold'},
											{value: 3, label: 'Transferred'},
											{value: 5, label: 'Lost'},
											{value: 6, label: 'Reserved'},
											{value: 7, label: 'Destroyed'},
											// {value: 8, label: 'Never Acquired'},
											{value: 9, label: 'Rented'},
										]}
									/>
								</div>
								<div className="statusFilter" style={{width: '110px'}}>
									<Select
										styles={this.customStyles}
										className={classNames('basic-single', {hasSelection: this.state.filter.used_firearm != null && this.state.filter.used_firearm.length})}
										classNamePrefix="select"
										onChange={this.doFilter}
										value={this.state.filterUsed}
										isClearable={true}
										isSearchable={true}
										name="used_firearm"
										placeholder={"Used..."}
										options={[
											{value: null, label: 'All'},
											{value: false, label: 'New'},
											{value: true, label: 'Used'},
										]}
									/>
								</div>
								<div className={"statusFilter"}>
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										name="caliber"
										property={properties.caliber}
										value={object.caliber}
										error={object.caliber_error}
										object={object.calibers}
										nullable={true}
									/>
								</div>
								<div className={"statusFilter"}>
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										name="manufacturer"
										property={properties.manufacturer}
										value={object.manufacturer}
										error={object.manufacturer_error}
										object={object.manufacturers}
										nullable={true}
									/>
								</div>
								<div className={"typeFilter"}>
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										name="type"
										property={properties.type}
										value={object.type}
										error={object.type_error}
										model={Types.Products_Types._name}
										id={'name'}
										nullable={true}
									/>
								</div>
								{<Button color="primary" onClick={this.handleToggleModalAdd} style={{marginLeft: '25px'}}>Launch Assisted Form 2</Button> }

								{this.renderHeaderRight("Products", columns, extraColumns, columnsAnchor, this.handleOpen, this.handleClose,
								)}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							pageSizeOptions={[5, 10, 20, 25, 50, 100, 500, 1000, 'All']}
							renderPageSizeOptions={this.renderPageSizes}
							pageSize={limit}
							className="-striped -highlight"
							getTrProps={(state, rowInfo) => {
								if (rowInfo && rowInfo.row) {
									return {
										style: {
											background: rowInfo.original.highlightRow ? 'yellow' : 'inherit',
										},
									};
								} else {
									return {};
								}
							}}
						/>


						<UniversalModalOverride
							locations={this.props.locations}
							states={this.props.states}
							history={this.props.history}
							title={"Assisted eForms Form 2"}
							object={Objects.ProductAddEForm}
							toggle={this.state.modalAdd}
							reportClose={this.handleReportProductClose}
							keepOpen = {this.state.keepOpen}
							afterSave={this.props.afterSave}
							submitLabel={'Launch Assisted eForms 2 or Add Another Line Item'}
							size={"xl"}
						/>

						<Modal
							isOpen={this.state.showEFormModal}
							toggle={() => this.setState({ showEFormModal: false })}
							centered // Optional: Centers the modal vertically/horizontally
							backdrop="static" // Matches your closeOnClickOutside: false (prevents backdrop close)
						>
							<ModalHeader toggle={() => this.setState({ showEFormModal: false })}>
								State Why You Intend To Make Firearm
							</ModalHeader>
							<ModalBody>
								<TextField
									fullWidth
									margin="dense"
									variant="outlined"
									name="transaction_purposes_atf"
									placeholder="Details / Explanation"
									value={this.state.transaction_purposes_atf}
									onChange={this.setFlagMessage}
								/>
								<div className="row" style={{ marginTop: '15px' }}>
									<div className="col-9">
										<span className="input-label">Use Default Form 1 Questions</span>
									</div>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={this.model.properties.use_default_form_one_questions}
											value={this.state.use_default_form_one_questions}
											error={this.state.use_default_form_one_questions_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</ModalBody>
							<ModalFooter>
								<button
									onClick={() => this.setState({ showEFormModal: false })}
									style={{ marginRight: '0', marginLeft: '10px' }}
									className="btn btn-default"
								>
									Cancel
								</button>
								<button
									onClick={async () => {
										const { data, products, selectedId } = this.state;
										let found = products.find((entry) => entry.pkey === selectedId);
										if (!found) {
											const product = data.find((entry) => entry.pkey === selectedId);
											if (product) {
												let eFormModel = new API.BuildClass(Types.E_Form_Logs._name, API.RequestType.CREATE);
												let pending_hash = await this.randomHash(16);
												this.setState({ // Updated to use setState for safety
													atf_hash: pending_hash,
													results: JSON.stringify(product),
													form_number: 1,
												});
												localStorage.setItem('e_form_hash', pending_hash);
												localStorage.setItem('use_default_questions', this.state.use_default_form_one_questions)
												await eFormModel.submit(this, API.RequestType.CREATE, true);
												this.props.history.push('/');
												this.props.history.push('/eForms_products');
												window.open('https://eforms.atf.gov/login', '_blank');
											}
										}
										this.setState({ showEFormModal: false });
									}}
									style={{ marginRight: '0', marginLeft: '10px' }}
									className="btn btn-success"
								>
									Save
								</button>
							</ModalFooter>
						</Modal>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
